module.exports = __webpack_public_path__ + "static/media/recharge-why-resilience-text-zh.289c3cdb.md";


//////////////////
// WEBPACK FOOTER
// ./src/data/playbooks/recharge-why-resilience-text-zh.md
// module id = 513
// module chunks = 18